import { createReducer, createAction } from '@reduxjs/toolkit';
import { getTranslation } from '../actions/translation';

export const setTranslationCache = createAction('translation/setCache');

const initialState = {
  loading: true,
  translations: {},
};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(getTranslation.fulfilled, (state, action) => ({
      ...state,
      translations: action.payload,
      loading: false,
    }))
    .addCase(setTranslationCache, (state, action) => ({
      ...state,
      translations: action.payload,
      loading: false,
    }));
});
